'use client';

import dynamic from 'next/dynamic';
import { useLearnData } from '../../../../context/LearnDataProvider';
import { CommonLearnBlockProps } from '../LearnBlock';

const EvidenceBasedGuidelinesBlock = dynamic(
  () => import('./EvidenceBasedGuidelinesBlock'),
);

/**
 * Wraps EvidenceBasedGuidelinesBlock so it can be lazy-loaded with next/dynamic.
 */
export default function EvidenceBasedGuidelinesWrapper(
  props: CommonLearnBlockProps,
): JSX.Element | null {
  const { learnData: clientLearnData } = useLearnData();
  const { sections: { guidelines = undefined } = {} } = clientLearnData || {};
  const showGuideLines = guidelines?.us?.length || guidelines?.uk?.length;

  return showGuideLines ? (
    <EvidenceBasedGuidelinesBlock guidelines={guidelines} {...props} />
  ) : null;
}
